// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"d9c0ec7c","186":"efb315c6","225":"2c39fce7","344":"b70e729b","372":"8ea34710","377":"9b5d9999","738":"0dfe27f4","841":"370b767c","856":"1fba98c8","862":"240a48b4","886":"b5446dd8"}[chunkId] + ".chunk.js";
};